module.exports = __webpack_public_path__ + "img/link_wallet.821041c0.png";